exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-711b2db0] .md-table-head-label {\n  color: #4caf50 !important;\n}\n[data-v-711b2db0] .md-table-head {\n  cursor: default;\n}\n.table-hover[data-v-711b2db0] {\n  cursor: pointer;\n}\n.label-total[data-v-711b2db0] {\n  float: right;\n  font-size: 14px;\n  font-weight: 500;\n}\n.label-total span[data-v-711b2db0] {\n    display: block;\n}\n.table-container[data-v-711b2db0] {\n  max-height: 600px;\n  overflow-y: auto;\n}\n", ""]);

// exports
